var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "#F6E7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 10.5251C12.3573 11.1872 12.099 11.9825 12.099 12.8371C12.099 15.1368 13.9698 17.0078 16.2697 17.0078C18.5693 17.0078 20.4403 15.1371 20.4403 12.8371C20.4403 10.5372 18.5696 8.6665 16.2697 8.6665C16.2632 8.6665 16.2567 8.66652 16.2503 8.66655C16.2439 8.66652 16.2374 8.6665 16.231 8.6665C14.797 8.6665 13.5327 9.40668 12.8 10.5251ZM13.5882 12.8372C13.5882 11.3588 14.7912 10.1558 16.2695 10.1558C17.7475 10.1558 18.9505 11.3588 18.9505 12.8372C18.9505 14.3152 17.7475 15.5182 16.2695 15.5182C14.7911 15.5182 13.5882 14.3152 13.5882 12.8372ZM14.9764 17.21C13.6451 17.21 12.4076 17.8165 11.5824 18.8722C10.9836 19.6381 10.6667 20.5542 10.6667 21.5198V23.3332H12.3328V21.5198C12.3328 20.0626 13.5186 18.8767 14.9761 18.8767H17.564C19.0212 18.8767 20.2074 20.0626 20.2074 21.5198V23.3332H21.874V21.5198C21.874 20.0649 21.1432 18.7171 19.9204 17.9153C19.2171 17.454 18.4022 17.21 17.5643 17.21H14.9764Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPersona);
export default __webpack_public_path__ + "static/media/My-persona.57de61d68457f1b21ea2327270c96731.svg";
export { ForwardRef as ReactComponent };